declare var apiConfig: any;
declare let dataLayer: any;
export const environment = {
  production: true,
  apiUrl: apiConfig.apiGatewayURL,
  ssoApiURL: apiConfig.ssoApiURL,
  ssoClientID: apiConfig.ssoClientID,
  accountSiteURL: apiConfig.accountSiteURL,
  uiTemplateBaseUrl: document.getElementsByTagName('base')[0].href + '/resources/static/src/assets',
  baseHref: document.getElementsByTagName('base')[0].href,
  customerName: apiConfig.customerName,
  templateVersion: apiConfig.templateVersion,
  portalId: 3,
  enrollSiteURL: apiConfig.enrollSiteURL,
  bestSellerCategoryId: 14,
  shopURL: apiConfig.shopURL,
  reportsURL: apiConfig.reportsURL,
  cookieDomain: apiConfig.cookieDomain || '.nextsphere.com',
  cookiePath: apiConfig.cookiePath || '/',
  legacyURL: apiConfig.legacyURL,
  cdnURL: apiConfig.cdnURL,
  accessToken: apiConfig.accessToken,
  refreshToken: apiConfig.refreshToken,
  idNonce: apiConfig.idNonce,
  memberId: apiConfig.memberId,
  defaultFBOID: apiConfig.defaultFBOID || '001002575619',
  cookieExpiryDays: apiConfig.cookieExpiryDays || 95,
  ipInfoApiUrl: apiConfig.ipInfoApiUrl || 'https://ipinfo.io',
  corporateUrl: window.location.origin,
  ssoApiUserURL: apiConfig.ssoApiUserURL,
  enableAuthentication: apiConfig.enableAuthentication,
  enableAuthorization: apiConfig.enableAuthorization,
  envName: apiConfig.envName,
  removeObsoleteCookies: apiConfig.removeObsoleteCookies,
  authenticatedLegacyRedirectUrl: apiConfig.authenticatedLegacyRedirectUrl || 'https://www.foreverliving.com',
  unauthenticatedLegacyRedirectUrl: apiConfig.unauthenticatedLegacyRedirectUrl || 'https://www.foreverliving.com/page/home-page',
  dataLayer: dataLayer,
  trainingsMenuRedirectUrl: apiConfig.trainingsMenuRedirectUrl || 'https://vimeo.com/forevernamerica/albums',
  cmsTemplateStylePath: apiConfig.cmsTemplateStylePath,
  cmsTemplateScriptPath: apiConfig.cmsTemplateScriptPath,
  cmsTemplateStyleIntegrity: apiConfig.cmsTemplateStyleIntegrity,
  cmsTemplateScriptIntegrity: apiConfig.cmsTemplateScriptIntegrity,
  recognitionMenuRedirectUrl: apiConfig.recognitionMenuRedirectUrl,
  guestToken: apiConfig.guestToken,
  errorMessage: apiConfig.errorMessage,
  enableLongPoll: apiConfig.enableLongPoll,
  longPollCount: apiConfig.longPollCount,
  betaPortal: apiConfig.betaPortal,
  nonWholesaleQualifiedFPCDiscount: apiConfig.nonWholesaleQualifiedFPCDiscount,
  enableRecognitionPage: apiConfig.enableRecognitionPage,
  betaEnabledCountries: apiConfig.betaEnabledCountries,
  sessionLogoutInterval: apiConfig.sessionLogoutInterval,
  sessionPopupInterval: apiConfig.sessionPopupInterval,
  enablePromotion: apiConfig.enablePromotion,
  promotionDisabledCountries: apiConfig.promotionDisabledCountries,
  allCountriesCorporateEnabled: apiConfig.allCountriesCorporateEnabled,
  flp360LoginUrl: apiConfig.flp360LoginUrl,
  flp360TitanSignupUrl: apiConfig.flp360TitanSignupUrl,
  flp360FeatureEnabled: apiConfig.flp360FeatureEnabled,
  shopPortalSubDomainName: apiConfig.shopPortalSubDomainName,
  accountPortalSubDomainName: apiConfig.accountPortalSubDomainName,
  joinPortalSubDomainName: apiConfig.joinPortalSubDomainName,
  reportsPortalSubDomainName: apiConfig.reportsPortalSubDomainName,
  corporatePortalSubDomainName:apiConfig.corporatePortalSubDomainName,
  legacyJoinUrl: apiConfig.legacyJoinUrl|| 'https://join.foreverliving.com',
  legacyShopUrl: apiConfig.legacyShopUrl|| 'https://shop.foreverliving.com',
  rallyPageEnabled: apiConfig.rallyPageEnabled,
  pfSignScriptEnabledStores: apiConfig.pfSignScriptEnabledStores || 'GRC,CYP',
  urlexclusions: apiConfig.urlexclusions || 'foto.foreverliving.com,globalpay.foreverliving.com',
  enableWHLSAL00ForAsstSupervisor: apiConfig.enableWHLSAL00ForAsstSupervisor || 'GBR,USA,CAN'
};

